import DatePicker from "@insite/mobius/DatePicker";
import { css } from "styled-components";

(DatePicker as any).defaultProps = {
    calendarIconProps: {
        color: "text.main",
        css: css`
            margin-right: -9px;
        `,
        src: "Calendar",
    },
    clearIconProps: {
        color: "text.main",
        src: "X",
    },
    cssOverrides: {
        formField: css`
            width: unset;
        `,
    },
    dateTimePickerProps: {
        calendarType: "US",
        showLeadingZeros: true,
        showFixedNumberOfWeeks: false,
        showNeighboringMonth: false,
    },
    format: "yyyy/MM/dd",
    placeholders: {
        dayPlaceholder: "dd",
        monthPlaceholder: "mm",
        yearPlaceholder: "yyyy",
        hourPlaceholder: "hr",
        minutePlaceholder: "min",
    },
};
// Non-functional change
